function Tips() {
    return (
    <div className="tips">
        <h2 className="tips-headline">TIPS AND TRICKS</h2>
        <p className="tips-text">Below are just a few tips you can use to work sustainable practices into your every day life.</p>
        <div className="tips-container">
            <div className="tip">
                <h3 className="tip-headline">Use reusable spray bottles</h3>
                <p className="tip-text">Buy glass spray bottles for household cleaning products that are refillable</p>
            </div>
            <div className="tip" id="two">
                <h3 className="tip-headline">Check ingredients on household products</h3>
                <p className="tip-text">Looks for biodegradable and non-toxic labels</p>
            </div>
            <div className="tip" id="three">
                <h3 className="tip-headline">Use public transportation when possible</h3>
                <p className="tip-text">Public transport and other alternatives helps reduce carbon emissions</p>
            </div>
            <div className="tip" id="four">
                <h3 className="tip-headline">Avoid single use waterbottles</h3>
                <p className="tip-text">Utilize reusable water bottles and tap water (there are great filtrations options out there)</p>
            </div>
            <div className="tip" id="five">
                <h3 className="tip-headline">Bring reusable bags to the store</h3>
                <p className="tip-text">Bring your own non-single-use bags to the store with you</p>
            </div>
            <div className="tip" id="six">
                <h3 className="tip-headline">Invest in reusable straws</h3>
                <p className="tip-text">Can't go without a straw? Buy metal/other reusable options to avoid single-use plastic.</p>
            </div>
            <div className="tip" id="two">
                <h3 className="tip-headline">Every little bit helps</h3>
                <p className="tip-text">Just try and make small changes - they can make a huge difference</p>
            </div>
        </div>
    </div>
    )
}

export default Tips